/* ===========================================================================
   Nota dos cards de produto, vinda da API de avaliações.

   Por que existe: o snippet custom-estrelas-card imprime a nota a partir dos
   metacampos reviews.rating / reviews.rating_count. Enquanto
   `sac_avaliacoes_config.sync_metafields_ativo` estiver desligado, há produto
   com avaliação na API e nenhum metacampo — e o card ficava sem nota nenhuma.

   Então este script varre os ganchos da página, pergunta à API em lote
   (endpoint de vitrine, até 50 por chamada) e preenche o que faltava ou corrige
   o que estava velho.

   O metacampo continua sendo a fonte do servidor: é o que o Google lê e o que
   aparece sem JS. Aqui só melhoramos o que o cliente vê.
   =========================================================================== */
(function () {
  'use strict';

  var LOTE = 50;

  var tag = document.currentScript ||
    document.querySelector('script[src*="custom-estrelas-card"]');
  if (!tag) return;

  var ehLocal = /^(127\.0\.0\.1|localhost)$/.test(location.hostname);
  var base = ((ehLocal && tag.dataset.apiDev) ? tag.dataset.apiDev : tag.dataset.api || '')
    .replace(/\/+$/, '');
  var loja = tag.dataset.loja || '';
  if (!base || !loja) return;

  var jaPedidos = {};

  function num(v) {
    var n = Number(v);
    return isFinite(n) ? n : 0;
  }

  /* Mesma regra do bloco da PDP: a estrela parcial fica entre 25% e 75% da
     largura dela, para 4,9 não parecer 5. */
  function pctEstrelas(nota) {
    var n = Math.max(0, Math.min(5, num(nota)));
    var cheias = Math.floor(n);
    var frac = n - cheias;
    if (frac > 0) frac = Math.min(0.75, Math.max(0.25, frac));
    return (cheias + frac) / 5 * 100;
  }

  /* Uma casa, truncando: 4,96 vira 4,9 (não 5,0). Arredondar inflaria a nota. */
  function notaTexto(media) {
    return (Math.floor(num(media) * 10) / 10).toFixed(1).replace('.', ',');
  }

  function milhar(n) {
    return String(num(n)).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  function pintar(el, d) {
    var total = num(d.total);
    if (!total) return;

    var estrelas = el.querySelector('.phe__stars');
    var nota = el.querySelector('.phe__nota');
    var qtd = el.querySelector('.phe__qtd');
    var txt = notaTexto(num(d.media));

    if (estrelas) estrelas.style.setProperty('--phe-pct', pctEstrelas(d.media).toFixed(2) + '%');
    if (nota) nota.textContent = txt;
    if (qtd && !el.hasAttribute('data-phe-sem-qtd')) qtd.textContent = '(' + milhar(total) + ')';

    el.setAttribute('aria-label', 'Nota ' + txt + ' de 5, ' + total + ' avaliações');
    el.hidden = false;
  }

  function buscar(ids, porId) {
    var u = base + '/v1/' + encodeURIComponent(loja) + '/resumos?produtos=' + ids.join(',');
    return fetch(u, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (j) {
        if (!j || j.success !== true) return;
        (j.data || []).forEach(function (d) {
          (porId[String(d.produto_id)] || []).forEach(function (el) { pintar(el, d); });
        });
      })
      .catch(function () { /* o metacampo já cobriu o caso comum: falhar aqui é silencioso */ });
  }

  function varrer() {
    var ganchos = document.querySelectorAll('[data-phe-produto]');
    if (!ganchos.length) return;

    var porId = {};
    var ids = [];
    Array.prototype.forEach.call(ganchos, function (el) {
      var id = el.getAttribute('data-phe-produto');
      if (!id) return;
      if (!porId[id]) {
        porId[id] = [];
        /* um id só é pedido uma vez por página, mesmo aparecendo em vários
           cards (vitrine + carrossel repetem produto) */
        if (!jaPedidos[id]) { jaPedidos[id] = 1; ids.push(id); }
      }
      porId[id].push(el);
    });

    /* já pedido antes: repinta com o que vier da próxima resposta, mas não
       dispara chamada nova */
    if (!ids.length) return;

    for (var i = 0; i < ids.length; i += LOTE) {
      buscar(ids.slice(i, i + LOTE), porId);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', varrer);
  } else {
    varrer();
  }

  /* vitrines carregadas por AJAX (scroll, filtro, gaveta) trazem cards novos */
  document.addEventListener('shopify:section:load', varrer);
  window.addEventListener('load', varrer);
})();
